import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as CloseIcon } from './../../assets/svgIcons/cross.svg';
import styles from './styles.module.css';

/**
 * Pure pill UI. A flex button with a label, optional sublabel (selected-state
 * info), and an IconButton on the right. The icon is either the default close
 * × or a custom one (arrow, etc.) — the parent picks which.
 *
 * Port of swlite's Chip (apps/smart-views/.../chip/Chip.tsx).
 */
const Chip = React.forwardRef(function Chip(
  {
    label,
    subLabel,
    customIcon,
    onButtonClick,
    onCrossClick,
    className = '',
    hideIcon = false,
    ...rest
  },
  ref
) {
  const handleIconClick = (event) => {
    onCrossClick?.(event);
  };

  return (
    <button
      ref={ref}
      type="button"
      className={`${styles.chip} ${className}`}
      onClick={onButtonClick}
      {...rest}>
      <span className={styles.chip_label} title={typeof label === 'string' ? label : ''}>
        {label}
      </span>
      {subLabel ? <span className={`${styles.chip_sublabel} sub-label`}>{subLabel}</span> : null}
      {!hideIcon ? (
        <span
          role="button"
          tabIndex={0}
          aria-label="Clear"
          className={styles.chip_icon}
          onPointerDown={handleIconClick}
          onClick={(event) => event.stopPropagation()}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              handleIconClick(event);
            }
          }}>
          {customIcon ?? <CloseIcon />}
        </span>
      ) : null}
    </button>
  );
});

Chip.propTypes = {
  label: PropTypes.node.isRequired,
  subLabel: PropTypes.node,
  customIcon: PropTypes.element,
  onButtonClick: PropTypes.func,
  onCrossClick: PropTypes.func,
  className: PropTypes.string,
  hideIcon: PropTypes.bool
};

export default Chip;
